import React, { FC, useCallback, useEffect, useMemo } from 'react'
import styles from 'styles/components/template.module.scss'
import { OLD_ADMIN_URL } from 'constants/config'
import { MainHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { getStoreName } from 'reducks/store/selectors'
import { State } from 'index'
import { MenuCard, LogoutMenuCard, StoreSwitchCardList, ReceiveCard, MemberCard, StaffPushCard } from 'components/Card'
import { NavButton, TextButton } from 'components/Button'
import { MemberModal } from 'components/Modal'
import { FlexRow } from 'components/Flex'
import { getIsAdmin, getRole, getStoreRef, getSwitchingStoreRefs } from 'reducks/auth/selectors'
import { Role } from 'lib/role'
import { updateEditState } from 'reducks/confirm/operations'
import { fetchStaffs } from 'reducks/staff/operations'
import { fetchStores } from 'reducks/store/operations'

const AccountTemplate: FC = () => {
  const dispatch = useDispatch()
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const role = useSelector((state: State) => getRole(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeName = useSelector((state: State) => getStoreName(state))
  const switchingStoreRefs = useSelector((state: State) => getSwitchingStoreRefs(state))
  const roleManager = new Role(role, storeRef)

  const isStoreAdmin = useMemo(() => roleManager.hasEnoughRole(9), [role, storeRef])
  const isStoreStaff = useMemo(() => roleManager.hasEnoughRole(5), [role, storeRef])
  const isAdminViewingStore = isAdmin && storeRef

  const openOldAdminSite = useCallback(() => {
    window.open(OLD_ADMIN_URL)
  }, [])

  // 店舗基本情報の編集画面でstore情報をrefetchするため
  useEffect(() => {
    dispatch(updateEditState(false))
  }, [])

  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchStaffs(storeRef, switchingStoreRefs))
  }, [storeRef, switchingStoreRefs])

  useEffect(() => {
    dispatch(fetchStores(true))
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      {storeName !== '' && (
        <>
          <MainHeadline headline={`${storeName}様`} />
          <Spacer size={20} />
        </>
      )}
      {isStoreAdmin && (
        <>
          <MenuCard isPrimary={true} label={'sacriで出品する商品の管理'} url={'/product'} />
          <Spacer size={12} />
        </>
      )}
      {isStoreStaff && (
        <>
          <MenuCard label={'売上を確認する'} url={'/account/revenue'} />
          <Spacer size={12} />
        </>
      )}
      {isStoreAdmin && (
        <>
          <MenuCard label={'商品の受け渡しに関する設定を修正する'} url={'/account/settings'} />
          <Spacer size={12} />
          <MenuCard label={'店舗の基本情報を修正する'} url={'/account/information/edit'} />
          <Spacer size={12} />
          <MenuCard label={'特定商取引法・インボイスに関する記載'} url={'/account/note'} />
          <Spacer size={12} />
          <MenuCard label={'契約情報を確認する'} url={'/contract'} />
          <Spacer size={12} />
          <MenuCard label={'sacriをお客さまに紹介する'} url={'/account/settings/deep_link'} />
        </>
      )}
      {!isAdmin && (
        <>
          <Spacer size={48} />
          <ReceiveCard />
        </>
      )}
      {!isAdmin && (
        <>
          <Spacer size={48} />
          <StaffPushCard />
        </>
      )}
      <Spacer size={48} />
      <StoreSwitchCardList />
      {(isStoreAdmin || isAdminViewingStore) && (
        <>
          <Spacer size={48} />
          <MemberCard />
        </>
      )}
      <Spacer size={48} />
      <LogoutMenuCard />
      <Spacer size={20} />
      <FlexRow justifyContent={'center'}>
        <TextButton label={'旧管理画面（配信等はできません、閲覧のみ）はこちら'} onClick={openOldAdminSite} />
      </FlexRow>
      <Spacer size={20} />
      <NavButton
        label={'トップページに戻る'}
        iconPath={'/icon/grey/home.svg'}
        url={isAdminViewingStore ? '/' : '/admin/shops'}
      />
      <Spacer size={72} />
      <MemberModal />
    </div>
  )
}

export default AccountTemplate
